import React from 'react';

const NoResultsPage = props => {
  return (
    <div className="no-results-page--wrapper">
      <p className="no-results-text">{props.noResultsText}</p>
      <div
        className="try-our-tools--wrapper"
        dangerouslySetInnerHTML={{ __html: props.tryOurToolsHtml }}
      />
      <div className="cards--wrapper">
        <div className="card--wrapper providers">
          <p className="find-label">{props.findProvidersLabel}</p>
          <a href={props.providersLink}>{props.providersLinktext}</a>
        </div>
        <div className="card--wrapper locations">
          <p className="find-label">{props.findLocationsLabel}</p>
          <a href={props.locationsLink}>{props.locationsLinktext}</a>
        </div>
        <div className="card--wrapper services-conditions-label">
          <p className="find-label">{props.findServicesConditionsLabel}</p>
          <a href={props.servicesConditionsLink}>
            {props.servicesConditionsLinktext}
          </a>
        </div>
      </div>
    </div>
  );
};

export default NoResultsPage;
